/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Operation } from '../../models/operation';
import { PrebidDto } from '../../models/prebid-dto';

export interface PatchPrebid$Params {
  id: number;
  allowExceedingCreditLimit?: boolean;
  'X-API-Version'?: string;
      body: Array<Operation>
}

export function patchPrebid(http: HttpClient, rootUrl: string, params: PatchPrebid$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidDto>> {
  const rb = new RequestBuilder(rootUrl, patchPrebid.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('allowExceedingCreditLimit', params.allowExceedingCreditLimit, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidDto>;
    })
  );
}

patchPrebid.PATH = '/api/prebids/{id}';
